export default __webpack_public_path__ + "static/media/activity-mood-icon.96d2d17f.svg";